/* Conmutador de colecciones · Peak | E-Commerce Lab · v3 */
(function () {
  if (window.__csSwitcherV3) return;
  window.__csSwitcherV3 = true;

  var mqMobile = window.matchMedia('(max-width: 749px)');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function isMobile() { return mqMobile.matches; }
  function inView(el) {
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    if (!r.width && !r.height) return false;
    var visible = Math.min(r.bottom, vh) - Math.max(r.top, 0);
    return visible > Math.min(r.height, vh) * 0.35;
  }

  /* ---------- Carrusel de productos ---------- */
  function initTrack(panel) {
    var track = panel.querySelector('[data-cs-track]');
    if (!track || track.dataset.csTrack) return;
    track.dataset.csTrack = '1';
    var cards = track.children;
    var dotsBox = panel.querySelector('[data-cs-dots]');
    var prev = panel.querySelector('[data-cs-prev]');
    var next = panel.querySelector('[data-cs-next]');

    if (dotsBox) {
      dotsBox.innerHTML = '';
      for (var i = 0; i < cards.length; i++) {
        var d = document.createElement('button');
        d.type = 'button'; d.className = 'cs-dot' + (i === 0 ? ' is-active' : ''); d.tabIndex = -1;
        (function (idx) { d.addEventListener('click', function () { goTo(idx); }); })(i);
        dotsBox.appendChild(d);
      }
    }
    function step() {
      if (!cards.length) return 0;
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      return cards[0].getBoundingClientRect().width + gap;
    }
    function goTo(idx) {
      var c = cards[idx]; if (!c) return;
      track.scrollTo({ left: c.offsetLeft - track.offsetLeft - (track.clientWidth - c.offsetWidth) / 2 * (isMobile() ? 1 : 0), behavior: 'smooth' });
    }
    function update() {
      var st = step(); if (!st) return;
      var idx = Math.round(track.scrollLeft / st);
      if (dotsBox) {
        var dots = dotsBox.children;
        for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-active', i === idx);
      }
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    var raf;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
    panel._csUpdate = update;
    update();
  }

  /* ---------- Movimiento de las pastillas ---------- */
  function initFx(root, tabs) {
    var fx = { timer: null, stopped: false, visible: false, hovering: false, ran: false };
    var trigger = root.dataset.fxTrigger || 'visible';
    var target = root.dataset.fxTarget || 'all';
    var dur = parseInt(root.dataset.fxDur, 10) || 900;
    var pause = parseInt(root.dataset.fxPause, 10);
    if (isNaN(pause)) pause = 3000;
    var stopOnClick = root.dataset.fxStop === 'true';

    function mode() {
      if (reduceMotion.matches) return 'none';
      return (isMobile() ? root.dataset.fxM : root.dataset.fxD) || 'none';
    }
    function clear() {
      clearTimeout(fx.timer); fx.timer = null;
      root.classList.remove('is-fx');
      tabs.forEach(function (t) { t.classList.remove('cs-go'); });
    }
    function targets() {
      return tabs.filter(function (t) { return target === 'all' || t.getAttribute('aria-selected') !== 'true'; });
    }
    function canRun() {
      if (fx.stopped || fx.hovering) return false;
      if (trigger === 'always') return true;
      return fx.visible;
    }
    function cycle() {
      clear();
      var m = mode();
      root.dataset.fxNow = m;
      if (m === 'none' || !canRun()) return;
      if (trigger === 'once' && fx.ran) return;
      if (m === 'float') { root.classList.add('is-fx'); fx.ran = true; return; }
      var list = targets();
      var stagger = Math.max(120, Math.round(dur * 0.45));
      list.forEach(function (t, i) {
        setTimeout(function () {
          if (!canRun()) return;
          t.classList.remove('cs-go'); void t.offsetWidth; t.classList.add('cs-go');
          setTimeout(function () { t.classList.remove('cs-go'); }, dur + 60);
        }, i * stagger);
      });
      fx.ran = true;
      if (trigger !== 'once') fx.timer = setTimeout(cycle, list.length * stagger + dur + pause);
    }
    function restart() { clear(); fx.timer = setTimeout(cycle, 400); }

    root.dataset.fxNow = mode();
    var watchEl = root.querySelector('[data-cs-tabs]') || root;
    root._csVis = function () {
      var v = inView(watchEl);
      if (v === fx.visible) return;
      fx.visible = v;
      if (v && !fx.timer && !root.classList.contains('is-fx')) restart();
      if (!v && trigger !== 'always') clear();
    };
    if (trigger === 'always') { fx.visible = true; restart(); }
    root._csVis();

    var bar = root.querySelector('[data-cs-tabs]');
    if (bar) {
      bar.addEventListener('mouseenter', function () { fx.hovering = true; clear(); });
      bar.addEventListener('mouseleave', function () { fx.hovering = false; if (!fx.stopped) restart(); });
    }
    root._csFxStop = function () { if (stopOnClick) { fx.stopped = true; clear(); } };
    root._csFxRestart = restart;
  }

  /* ---------- Indicador deslizante, orillas y pista de deslizamiento ---------- */
  function placeIndicator(root) {
    var ind = root.querySelector('[data-cs-ind]');
    if (!ind) return;
    var on = root.querySelector('.cs-tab[aria-selected="true"]');
    if (!on) return;
    ind.style.width = on.offsetWidth + 'px';
    ind.style.height = on.offsetHeight + 'px';
    ind.style.transform = 'translate(' + on.offsetLeft + 'px,' + on.offsetTop + 'px)';
    if (!ind.classList.contains('is-ready')) {
      ind.style.transition = 'none'; void ind.offsetWidth; ind.style.transition = '';
      ind.classList.add('is-ready');
      root.classList.add('is-ind');
    }
  }
  function updateFade(root) {
    var wrap = root.querySelector('[data-cs-tabs-wrap]');
    var bar = root.querySelector('[data-cs-tabs]');
    if (!wrap || !bar) return;
    var over = bar.scrollWidth > bar.clientWidth + 2;
    wrap.classList.toggle('is-more-l', over && bar.scrollLeft > 4);
    wrap.classList.toggle('is-more-r', over && bar.scrollLeft < bar.scrollWidth - bar.clientWidth - 4);
  }
  function hint(root) {
    if (root.dataset.hintM !== 'true' || !isMobile() || reduceMotion.matches || root._csHinted) return;
    var bar = root.querySelector('[data-cs-tabs]');
    if (!bar || bar.scrollWidth <= bar.clientWidth + 2) return;
    root._csHinted = true;
    setTimeout(function () {
      bar.style.scrollSnapType = 'none';
      bar.scrollTo({ left: 56, behavior: 'smooth' });
      setTimeout(function () { bar.scrollTo({ left: 0, behavior: 'smooth' }); }, 650);
      setTimeout(function () { bar.style.scrollSnapType = ''; }, 1400);
    }, 500);
  }

  /* ---------- Conmutador ---------- */
  function initSwitcher(root) {
    if (!root || root.dataset.csReady) return;
    root.dataset.csReady = '1';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[role="tabpanel"]'));
    panels.forEach(initTrack);
    var bar = root.querySelector('[data-cs-tabs]');

    function show(i, opts) {
      opts = opts || {};
      tabs.forEach(function (t, j) {
        var on = j === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (panels[j]) panels[j].hidden = !on;
      });
      var p = panels[i];
      if (p) {
        var tr = p.querySelector('[data-cs-track]');
        if (tr) tr.scrollLeft = 0;
        if (p._csUpdate) p._csUpdate();
      }
      placeIndicator(root);
      if (opts.focus) tabs[i].focus();
      if (opts.scroll && bar && bar.scrollWidth > bar.clientWidth) {
        bar.scrollTo({ left: tabs[i].offsetLeft - (bar.clientWidth - tabs[i].offsetWidth) / 2, behavior: 'smooth' });
      }
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        if (root._csFxStop) root._csFxStop();
        show(i, { scroll: true });
      });
      tab.addEventListener('keydown', function (e) {
        var n = tabs.length, k = null;
        if (e.key === 'ArrowRight') k = (i + 1) % n;
        if (e.key === 'ArrowLeft') k = (i - 1 + n) % n;
        if (e.key === 'Home') k = 0;
        if (e.key === 'End') k = n - 1;
        if (k !== null) { e.preventDefault(); show(k, { focus: true, scroll: true }); }
      });
    });

    if (bar) bar.addEventListener('scroll', function () { updateFade(root); }, { passive: true });
    root._csShow = function (blockId) {
      var idx = tabs.findIndex(function (t) { return t.dataset.blockId === blockId; });
      if (idx > -1) show(idx, { scroll: true });
    };
    root._csLayout = function () {
      placeIndicator(root); updateFade(root);
      panels.forEach(function (p) { if (!p.hidden && p._csUpdate) p._csUpdate(); });
    };

    if (tabs.length) initFx(root, tabs);
    root._csLayout();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { root._csLayout(); });

    root._csHintCheck = function () { if (!root._csHinted && inView(bar || root)) hint(root); };
    root._csHintCheck();
  }

  /* ---------- Countdown ---------- */
  function initCountdown(el) {
    if (!el || el.dataset.csCd) return;
    el.dataset.csCd = '1';
    var raw = (el.dataset.end || '').trim().replace(' ', 'T');
    if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) raw += 'T23:59';
    if (/T\d{1,2}:\d{2}$/.test(raw)) raw = raw.replace(/T(\d):/, 'T0$1:') + ':00';
    var end = new Date(raw + (el.dataset.tz || '-06:00')).getTime();
    if (isNaN(end)) { console.warn('[Conmutador] Fecha de countdown inválida:', el.dataset.end); return; }
    var q = function (u) { return el.querySelector('[data-u="' + u + '"]'); };
    var dEl = q('d'), hEl = q('h'), mEl = q('m'), sEl = q('s');
    var dUnit = el.querySelector('.cs-cd-unit--d'), dSep = dUnit && dUnit.nextElementSibling;
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var timer;
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        clearInterval(timer);
        if (el.dataset.expired === 'message') {
          var u = el.querySelector('.cs-cd-units'); if (u) u.hidden = true;
          var l = el.querySelector('.cs-cd-label'); if (l) l.hidden = true;
          var done = el.querySelector('.cs-cd-done'); if (done) done.hidden = false;
          el.hidden = false;
        } else { el.hidden = true; }
        return;
      }
      var t = Math.floor(diff / 1000);
      var d = Math.floor(t / 86400), h = Math.floor(t % 86400 / 3600), m = Math.floor(t % 3600 / 60), sec = t % 60;
      if (dEl) dEl.textContent = pad(d);
      if (dUnit) { dUnit.hidden = d === 0; if (dSep) dSep.hidden = d === 0; }
      hEl.textContent = pad(h); mEl.textContent = pad(m); sEl.textContent = pad(sec);
      el.hidden = false;
    }
    timer = setInterval(tick, 1000);
    tick();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-cs]').forEach(initSwitcher);
    (scope || document).querySelectorAll('[data-cs-countdown]').forEach(initCountdown);
  }

  var st;
  function checkViews() {
    document.querySelectorAll('[data-cs]').forEach(function (r) {
      if (r._csVis) r._csVis();
      if (r._csHintCheck) r._csHintCheck();
    });
  }
  window.addEventListener('scroll', function () { if (st) return; st = setTimeout(function () { st = null; checkViews(); }, 150); }, { passive: true });
  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () {
      document.querySelectorAll('[data-cs]').forEach(function (r) { if (r._csLayout) r._csLayout(); });
      checkViews();
    }, 120);
  });
  var onBp = function () {
    document.querySelectorAll('[data-cs]').forEach(function (r) { if (r._csFxRestart) r._csFxRestart(); });
  };
  if (mqMobile.addEventListener) mqMobile.addEventListener('change', onBp); else if (mqMobile.addListener) mqMobile.addListener(onBp);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var root = document.getElementById('cs-' + e.detail.sectionId);
    if (root && root._csShow) root._csShow(e.detail.blockId);
  });
})();
